export default function stopShowingTour(tourId) {
    localStorage.setItem('assessmentServicesTourStatus-' + tourId, 'stop');
    return this;
}